(ns ballot-scout-v2-frontend.events
  (:require
   [ajax.edn :refer [edn-request-format edn-response-format]]
   [ballot-scout-v2-frontend.api-urls :as urls]
   [ballot-scout-v2-frontend.auth :as auth]
   [ballot-scout-v2-frontend.db :as db]
   [ballot-scout-v2-frontend.request-helpers :as request-helpers]
   [cljs.core.async :refer [go] :as async]
   [cljs.core.async.interop :refer-macros [<p!]]
   [clojure.string :as str]
   [day8.re-frame.async-flow-fx]  ;; Don't remove this! (https://github.com/day8/re-frame-http-fx#step-2-registration-and-use)
   [day8.re-frame.http-fx]        ;; Don't remove this! (See above)
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [re-frame.core :as rf]))

(rf/reg-fx
 ::scroll-to
 (fn [x y]
   (.scroll js/window x y)))

(rf/reg-event-db
 ::initialize-db
 (fn-traced [_ _]
   db/default-db))

(rf/reg-event-db
 ::trigger-404
 (fn [db _]
   (assoc db :current-route :404)))

(rf/reg-event-db
 ::set-current-route
 (fn [db [_ route]]
   (assoc db :current-route route)))

(rf/reg-event-fx
 ::send-ajax-call
 (fn [_ [_ token opts]]
   {:http-xhrio (assoc opts :headers {"Authorization" (str "Bearer " token)})}))

(rf/reg-fx
 ;; this effect mimics the `:http-xhrio` effect but it injects the auth token
 ;; for you. If your token is expired, it redirects you to the login page
 ::ajax
 (fn [opts]
   (auth/do-with-token!
    #(rf/dispatch [::send-ajax-call % opts])
    #(rf/dispatch [::auth/redirected-login]))))

(rf/reg-event-fx
 ::fetch-partner
 (fn [_ [_ partner-id-or-slug]]
   {::ajax {:method :get
            :uri (urls/partner-by-id-or-slug partner-id-or-slug)
            :format (edn-request-format)
            :response-format (edn-response-format)
            :on-success [::fetch-partner-success partner-id-or-slug]
            :on-failure [::fetch-partner-failure partner-id-or-slug]}}))

(rf/reg-event-fx
 ::fetch-partner-success
 (fn [{:keys [db]} [_ partner-id-or-slug response]]
   {:db (db/add-entity db response)
    :dispatch [::request-helpers/clear-failed-request [::fetch-partner partner-id-or-slug]]}))

(rf/reg-event-fx
 ::fetch-partner-failure
 (fn [_ [_ partner-id-or-slug response]]
   {:dispatch [::request-helpers/request-failed [::fetch-partner partner-id-or-slug] response]}))

(rf/reg-event-fx
 ::fetch-all-partners
 (fn [_ _]
   {::ajax {:method :get
            :uri urls/all-partners
            :format (edn-request-format)
            :response-format (edn-response-format)
            :on-success [::fetch-all-partners-success]
            :on-failure [::fetch-all-partners-failure]}}))

(rf/reg-event-fx
 ::fetch-all-partners-success
 (fn [{:keys [db]} [_ response]]
   {:db (reduce db/add-entity db response)
    :dispatch [::request-helpers/clear-failed-request [::fetch-all-partners]]}))

(rf/reg-event-fx
 ::fetch-all-partners-failure
 (fn [_ [_ response]]
   {:dispatch [::request-helpers/request-failed [::fetch-all-partners] response]}))

(rf/reg-event-fx
 ::fetch-jurisdiction
 (fn [_ [_ id-or-slug]]
   {::ajax {:method :get
            :uri (urls/jurisdiction-by-id-or-slug id-or-slug)
            :format (edn-request-format)
            :response-format (edn-response-format)
            :on-success [::fetch-jurisdiction-success id-or-slug]
            :on-failure [::fetch-jurisdiction-failure id-or-slug]}}))

(rf/reg-event-fx
 ::fetch-jurisdiction-success
 (fn [{:keys [db]} [_ id-or-slug response]]
   {:db (db/add-entity db response)
    :dispatch [::request-helpers/clear-failed-request [::fetch-jurisdiction id-or-slug]]}))

(rf/reg-event-fx
 ::fetch-jurisdiction-failure
 (fn [_ [_ id-or-slug response]]
   {:dispatch [::request-helpers/request-failed [::fetch-jurisdiction id-or-slug] response]}))

(rf/reg-event-fx
 ::fetch-elections-for-jurisdiction
 (fn [_ [_ jurisdiction-slug]]
   {::ajax {:method :get
            :uri (urls/elections-for-jurisdiction jurisdiction-slug)
            :format (ajax.edn/edn-request-format)
            :response-format (ajax.edn/edn-response-format)
            :on-success [::fetch-elections-for-jurisdiction-success jurisdiction-slug]
            :on-failure [::fetch-elections-for-jurisdiction-failure jurisdiction-slug]}}))

(rf/reg-event-fx
 ::fetch-elections-for-jurisdiction-success
 (fn [{:keys [db]} [_ jurisdiction-slug response]]
   {:db (db/add-elections-to-jurisdiction db jurisdiction-slug response)
    :dispatch
    [::request-helpers/clear-failed-request
     [::fetch-elections-for-jurisdiction jurisdiction-slug]]}))

(rf/reg-event-fx
 ::fetch-elections-for-jurisdiction-failure
 (fn [_ [_ jurisdiction-slug response]]
   {:dispatch [::request-helpers/request-failed [::fetch-elections-for-jurisdiction jurisdiction-slug] response]}))

(rf/reg-event-fx
 ::fetch-elections-for-partner
 (fn [_ [_ partner-slug]]
   {::ajax {:method :get
            :uri (urls/elections-for-partner partner-slug)
            :format (ajax.edn/edn-request-format)
            :response-format (ajax.edn/edn-response-format)
            :on-success [::fetch-elections-for-partner-success partner-slug]
            :on-failure [::fetch-elections-for-partner-failure partner-slug]}}))

(rf/reg-event-fx
 ::fetch-elections-for-partner-success
 (fn [{:keys [db]} [_ partner-slug response]]
   {:db (db/add-elections-to-partner db partner-slug response)
    :dispatch
    [::request-helpers/clear-failed-request
     [::fetch-elections-for-partner partner-slug]]}))

(rf/reg-event-fx
 ::fetch-elections-for-partner-failure
 (fn [_ [_ partner-slug response]]
   {:dispatch [::request-helpers/request-failed [::fetch-elections-for-partner partner-slug] response]}))

(rf/reg-event-fx
 ::validate-route-and-cache-slugs
 (fn [{:keys [db]} [_ route]]
   (let [{:keys [partner-slug jurisdiction-slug election-slug]} (:path-params route)
         partner (db/partner-by-slug db partner-slug)
         jurisdiction (db/jurisdiction-by-slug db jurisdiction-slug)
         election (db/election-by-slug-and-partner-id db election-slug (:partner/id partner))

         partner-doesnt-exist (and (some? partner-slug)
                                   (nil? partner))
         juri-doesnt-belong-to-partner (and (some? jurisdiction-slug)
                                            (some? partner-slug)
                                            (not= (:jurisdiction/partner-id jurisdiction)
                                                  (:partner/id partner)))
         election-doesnt-exist-for-juri (and (some? election-slug)
                                             (some? jurisdiction-slug)
                                             (not (db/jurisdiction-has-election? db jurisdiction-slug election)))
         election-doesnt-exist (and (some? election-slug) (nil? election))]
     (if (or election-doesnt-exist
             partner-doesnt-exist
             juri-doesnt-belong-to-partner
             election-doesnt-exist-for-juri)
       {:dispatch [::trigger-404]}
       {:dispatch-n [(when (some? election-slug)
                       [::cache-current-election election-slug])]}))))

(defn load-partner-and-jurisdiction-from-route-flow
  [route]
  (let [partner-slug (get-in route [:path-params :partner-slug])
        jurisdiction-slug (get-in route [:path-params :jurisdiction-slug])]
    {:first-dispatch [::fetch-partner partner-slug]
     :rules [{:when     :seen?
              :events   ::fetch-partner-success
              :dispatch [::fetch-jurisdiction jurisdiction-slug]}
             {:when     :seen-both?
              :events   [::fetch-partner-success
                         ::fetch-jurisdiction-success]
              :dispatch [::fetch-elections-for-jurisdiction jurisdiction-slug]}
             {:when     :seen-all-of?
              :events   [::fetch-partner-success
                         ::fetch-jurisdiction-success
                         ::fetch-elections-for-jurisdiction-success]
              :dispatch [::validate-route-and-cache-slugs route]
              :halt?    true}]}))

(defn load-jurisdiction-from-route-flow
  [route]
  (let [jurisdiction-slug (get-in route [:path-params :jurisdiction-slug])]
    (-> route
        load-partner-and-jurisdiction-from-route-flow
        (assoc :first-dispatch [::fetch-jurisdiction jurisdiction-slug])
        (update :rules rest))))

(defn load-partner-from-route-flow
  [route]
  (let [partner-slug (get-in route [:path-params :partner-slug])]
    {:first-dispatch [::fetch-partner partner-slug]
     :rules [{:when     :seen?
              :events   ::fetch-partner-success
              :dispatch [::fetch-elections-for-partner partner-slug]}
             {:when     :seen-all-of?
              :events   [::fetch-partner-success
                         ::fetch-elections-for-partner-success]
              :dispatch [::validate-route-and-cache-slugs route]
              :halt?    true}]}))

(rf/reg-event-fx
 ::load-jurisdiction-route
 (fn [{:keys [db]} [_ route]]
   (let [partner-slug (get-in route [:path-params :partner-slug])
         jurisdiction-slug (get-in route [:path-params :jurisdiction-slug])]
     (cond
       (nil? (db/partner-by-slug db partner-slug))
       {:async-flow (load-partner-and-jurisdiction-from-route-flow route)}

       (and (some? jurisdiction-slug)
            (nil? (db/jurisdiction-elections db jurisdiction-slug)))
       {:async-flow (load-jurisdiction-from-route-flow route)}

       :else
       {:dispatch [::validate-route-and-cache-slugs route]}))))

(rf/reg-event-fx
 ::load-partner-route
 (fn [{:keys [db]} [_ route]]
   (let [partner-slug (get-in route [:path-params :partner-slug])]
     (if (nil? (db/partner-by-slug db partner-slug))
       {:async-flow (load-partner-from-route-flow route)}
       {:dispatch [::validate-route-and-cache-slugs route]}))))

(rf/reg-event-fx
 ::load-import-for-route
 (fn [{:keys [db]} [_ route]]
   (let [import-id (get-in route [:path-params :import-id])]
     (when-not (db/import-by-id db import-id)
       {:dispatch [:ballot-scout-v2-frontend.import-manager.events/fetch-import import-id]}))))

(rf/reg-event-fx
 ::load-disposition-for-route
 (fn [{:keys [db]} [_ route]]
   (let [dispo-id (get-in route [:path-params :disposition-id])]
     (when-not (db/disposition-by-id db dispo-id)
       {:dispatch [:ballot-scout-v2-frontend.disposition-manager.events/fetch-disposition dispo-id]}))))

(rf/reg-event-fx
 ::mark-index-page-ready
 (fn [{:keys [db]} [_ _]]
   {:db (assoc db :index-page-ready? true)}))

(rf/reg-event-fx
 ::prep-index-page
 (fn [_ [_ _]]
   {:dispatch [::auth/fetch-profile-if-logged-in
               #(rf/dispatch [::mark-index-page-ready])]}))

;; cache the election slug so that sidebar components can link to pages requiring an election
(rf/reg-event-db
 ::cache-current-election
 (fn [db [_ election-slug]]
   (assoc db :cached-election-slug election-slug)))

;; effect for setInterval, useful for polling

(rf/reg-fx
 :interval
 (let [live-intervals (atom {})]
   (fn [{:keys [action id ms dispatch]}]
     (if (= action :start)
       (do
         (when-let [existing-poll (get @live-intervals id)]
           (js/clearInterval existing-poll))
         (swap! live-intervals assoc id (js/setInterval #(rf/dispatch dispatch) ms)))
       (do (js/clearInterval (get @live-intervals id))
           (swap! live-intervals dissoc id))))))

;; Document title manipulation

(rf/reg-event-db
 ::set-page-name
 (fn [db [_ page-name]]
   (assoc db :page-name page-name)))

(rf/reg-event-db
 ::clear-page-name
 (fn [db _]
   (dissoc db :page-name)))

;; Mobile

(rf/reg-event-db
 ::set-view-mobile-menu
 (fn [db [_ bool]]
   (assoc db :view-mobile-menu bool)))

(rf/reg-event-fx
 ::scroll-to-top
 (fn [_ [_ _]]
   {:fx [[::scroll-to 0 0]]}))

;; file operations

(def utf8-decoder (js/TextDecoder. "utf-8"))
(def newline-re #"\r?\n")

(rf/reg-fx
 ::fetch-lines
 ;; This effect allows you to process line-by-line the contents of the file at the
 ;; given URL in a memory efficient manner.
 ;;
 ;; Options :-
 ;;   url - URL to fetch the file from
 ;;   on-line - callback that is called on every line that is read in the file
 ;;   on-complete - callback that is called when this effect completes
 ;;   limit - number of lines to read before terminating
 (fn [{:keys [url limit on-line on-complete]}]
   (go
     (let [response-p (.fetch js/window url)
           stream (.-body (<p! response-p))
           rdr (.getReader stream)]

      ;; loop over chunks from the foreign file and trigger the on-line callback
      ;; for each line parsed
       (loop [line-acc "" line-idx 0]
         (let [{:keys [value] :as read-result} (js->clj (<p! (.read rdr)) :keywordize-keys true)
               done? (:done read-result)
               chunk (if value (.decode utf8-decoder value) "")
               splits (str/split chunk newline-re)
               first-line (str line-acc (first splits))
               rem (if limit
                     (- limit line-idx)
                     js/Infinity)]
           (cond
             done?
             (dorun (->> splits rest (cons first-line) (take rem) (map on-line)))

             (re-find newline-re chunk)
             (let [lines (->> splits rest butlast (cons first-line) (take rem))]
               (dorun (map on-line lines))
               (when (or (not limit)
                         (< (+ (count lines) line-idx) limit))
                 (recur (last splits) (+ (count lines) line-idx))))

             :else
             (recur (str line-acc chunk) line-idx))))
       (when on-complete
         (on-complete))))))

(rf/reg-event-db
 ::hide-banner
 (fn [db [_ _]]
   (assoc db :show-banner? false)))
